<template>
    <router-link :to="`/auction-works/${work._id}`" class="gallery-card">
        <div class="gallery-card__img-wrap">
            <v-img contain :aspect-ratio="1 / 1" :src="work?.imgs?.[0]?.url" class="grey-ef" />
        </div>
        <div class="gallery-card__con">
            <div class="py-10 py-md-14">
                <div>
                    <strong class="font-size-14 font-weight-medium">LOT. {{ work?.lot }}</strong>
                </div>
                <div class="mt-8 mt-md-10 ellip">
                    <strong class="font-size-20 font-size-md-24 font-weight-medium font-notoserif">{{ work?.author?.name?.ko }}</strong>
                </div>
                <div class="mt-md-2 ellip">
                    <span class="font-size-16 font-size-md-18 font-notoserif">{{ work?.subject }}</span>
                </div>
                <div class="mt-10 mt-md-12">
                    <span class="font-size-14 grey-68--text">{{ work?.year }} ㅣ {{ work?.material }} ㅣ {{ work?.dimensionTag }}</span>
                </div>
            </div>
            <template v-if="isProgram">
                <v-divider class="grey-da"></v-divider>
                <div class="font-size-14 py-10 py-md-16">
                    <v-row no-gutters align="baseline">
                        <v-col cols="3">
                            <span>추정가</span>
                        </v-col>
                        <v-col cols="9">
                            <div class="grey-68--text pl-sm-12">KRW {{ work?.price_estimated?.from?.format?.() || "0" }} ~ {{ work?.price_estimated?.to?.format?.() || "" }}</div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters align="baseline" class="mt-2 mt-md-4">
                        <v-col cols="3">
                            <span>시작가</span>
                        </v-col>
                        <v-col cols="9">
                            <div class="grey-68--text pl-sm-12">KRW {{ work?.price_auction?.from?.format?.() || "0" }}</div>
                        </v-col>
                    </v-row>
                    <v-row no-gutters align="baseline" class="font-weight-medium mt-2 mt-md-4">
                        <v-col cols="3">
                            <span>현재가</span>
                        </v-col>
                        <v-col cols="9">
                            <div class="pl-sm-12">KRW {{ work?.price_auction?.current?.format?.() || "0" }}</div>
                        </v-col>
                    </v-row>
                </div>
                <v-divider class="grey-da"></v-divider>
                <div class="d-flex flex-wrap align-center justify-space-between py-6 py-md-8">
                    <auction-work-until :work="work" class="font-size-14 grey-68--text" />
                    <auction-work-action v-bind="{ work }">
                        <v-btn slot="on-going" small color="primary">응찰하기</v-btn>
                        <v-btn slot="finished" small color="grey-c7" class="px-26" dark>마감</v-btn>
                    </auction-work-action>
                </div>
            </template>
            <v-divider class="primary"></v-divider>
        </div>
    </router-link>
</template>

<script>
import { WORK_AUCTION_MODES } from "@/assets/variables";
import AuctionWorkUntil from "./auction-work-until.vue";
import AuctionWorkAction from "./auction-work-action.vue";
export default {
    components: {
        AuctionWorkUntil,
        AuctionWorkAction,
    },
    props: ["work"],
    computed: {
        isProgram() {
            return this.work?.mode_auction == WORK_AUCTION_MODES.PROGRAM.value;
        },
    },
};
</script>

<style></style>
